// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"6be979d1","367":"6bac4215","616":"11165e29"}[chunkId] + ".chunk.css";
};